import { ApiService } from "../../../config";

export type FrequenciaRecorrencia = "SEMANAL" | "MENSAL";

export type PostagemRecorrente = {
  externalId: string;
  searchUrl: string | null;
  frequencia: FrequenciaRecorrencia;
  diaSemana: string | null;
  diaMes: number | null;
  dataFinal: string;
  criadoEm: string | null;
};

export type PostagensRecorrentes = {
  habilitado: boolean;
  itens: PostagemRecorrente[];
};

export type PostagemRecorrenteRequest = {
  topicType: string;
  summary: string;
  languageCode?: string;
  media?: { mediaFormat: string; sourceUrl: string }[];
  event: { title: string; startTime: string; endTime: string };
  offer?: { couponCode?: string; redeemOnlineUrl?: string; termsConditions?: string };
  callToAction?: { actionType?: string; url?: string };
  recorrencia: {
    frequencia: FrequenciaRecorrencia;
    diaSemana: string | null;
    diaMes: number | null;
    dataFinal: string;
  };
};

type Envelope<T> = { message?: string; error?: boolean; data?: T };

const unwrap = <T>(response: { data?: Envelope<T> }): T => {
  const body = response?.data;
  if (!body || body.error) {
    throw new Error(body?.message || "Não foi possível concluir a operação.");
  }
  return body.data as T;
};

export const SEM_RECORRENCIA: PostagensRecorrentes = { habilitado: false, itens: [] };

export const postagensRecorrentesApi = {
  // Backend antigo (sem o endpoint) ou flag desligada: a opção simplesmente não aparece.
  async listar(publicId: string): Promise<PostagensRecorrentes> {
    try {
      const r = unwrap<PostagensRecorrentes>(
        await ApiService.get(`/business-profiles/${publicId}/postagens-recorrentes`),
      );
      return { habilitado: Boolean(r?.habilitado), itens: Array.isArray(r?.itens) ? r.itens : [] };
    } catch {
      return SEM_RECORRENCIA;
    }
  },

  async criar(publicId: string, body: PostagemRecorrenteRequest): Promise<PostagemRecorrente> {
    return unwrap(await ApiService.post(`/business-profiles/${publicId}/postagens-recorrentes`, body));
  },
};
